/**
 * @desc 分页+明细
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductMasterResponseDto>
>;
export function request(
  params: API.basics.productMaster.pageDetails.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/page/details`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
